import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-corner-ending-f',
  templateUrl: './corner-ending-f.component.html',
  styleUrls: ['./corner-ending-f.component.scss']
})
export class CornerEndingFComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
